import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';
import * as _ from 'lodash';

@Injectable()
export class LocalStorageService {

  private secretKey: string = "my-secret-key";

  constructor() { }


  /**
   * Function to set encrypted value in localstorage
   * @param key string
   * @param val string or object
   */
  setItem(key: string, val: any) {

    let parsedVal;
    // Check whether value is an object
    if (_.isObject(val) || _.isArray(val)) {
      parsedVal = _.attempt(JSON.stringify.bind(null, val));
    }
    // If value is string
    else if (_.isString(val)) {
      parsedVal = val;
    }else if(_.isBoolean(val)){
      parsedVal = JSON.stringify(val);
    }else if(_.isNumber(val)){
      parsedVal = val.toString();
    }
    // Encrypt key and store in localStorage
    if (!_.isError(parsedVal) && !_.isUndefined(parsedVal)) {
      parsedVal = crypto.AES.encrypt(parsedVal, this.secretKey)
      key= key.toLowerCase();
      localStorage.setItem(key, parsedVal);
     // debugger;
    }
  }//set-item-closes


  /**
   * Remove specific key from localStorage
   * @param key string
   */
  removeItem(key: string) {
    localStorage.removeItem(key);
  }


  /**
   * Function to get decrypted item from localstorage
   * @param key string
   */
  getItem(key: string) {
    key= key.toLowerCase();
    let retrievedVal = localStorage.getItem(key);
    if (_.isNull(retrievedVal)) {
      return null;
    }
    let decryptedVal: any = this.getDescryptedVal(retrievedVal, this.secretKey);
    // value modified by user
    if (_.isError(decryptedVal) || _.isEmpty(decryptedVal)) {
      this.removeItem(key);
      return null;
    }
    let decryptedObj = null ; 
    if(decryptedVal == "true"){
      decryptedObj = true;
    }else if(decryptedVal == "false"){
      decryptedObj = false;
    }else{
      decryptedObj = _.attempt(JSON.parse.bind(null, decryptedVal));
    }
    return _.isError(decryptedObj) ? decryptedVal : decryptedObj;
  }




  /**
   * Function to decrypt value
   * @param val string
   * @param secretKey string
   */
  getDescryptedVal(val: string, secretKey: string) {
    let decryptObj = crypto.AES.decrypt(val, this.secretKey);
    return _.attempt(_.invoke, decryptObj, "toString", crypto.enc.Utf8);
  }


  /**
    * Function to clear LocalStorage
    */
  clearLocalStorage() {
    localStorage.clear();
  }
}//Service-closes
